document.addEventListener('DOMContentLoaded', () => {
  const run = document.getElementsByClassName('question');

  const save = () => {
    const csrfToken = document.querySelector("[name='csrf-token']").content;
    const userSurvey = document.querySelector('#user-survey').value;

    const answers = [...document.querySelectorAll('.option:checked')].map((option) => {
      return { question_id: option.dataset.question, option_id: option.value }
    });

    fetch(`/user_surveys/${userSurvey}/answers`, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': csrfToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ answers: answers })
    });
  };

  if (run.length > 0) {
    const options = document.querySelectorAll('.option');
    let optionsChecked = Number(document.getElementById('selected-options-counter').value);
    const questionsCount = Number(document.getElementById('total-questions-counter').value);

    const questionCounter = document.getElementById('selected-questions-count');

    const nextButton = document.getElementById('next-question');

    if (nextButton) {
      nextButton.addEventListener('click', (event) => {
        if (optionsChecked < questionsCount) {
          event.preventDefault();
          return false;
        } else {
          return true;
        }
      });
    }

    options.forEach((option) => {
      option.addEventListener('change', (event) => {
        const multiSelect = event.currentTarget.hasAttribute('data-multiselect');
        const scaleSelect = event.currentTarget.hasAttribute('data-scaleselect');

        if (!multiSelect && !scaleSelect) {
          optionsChecked = 0;
          options.forEach((option) => {
            if (option !== event.currentTarget) {
              option.checked = false;
            }
          });
        }

        if(scaleSelect) {
          const container = event.currentTarget.parentElement.parentElement;
          const currentIndex = Number(event.currentTarget.dataset.index);

          container.dataset.count = 1;

          optionsChecked = Array.prototype.map.call(
            document.querySelectorAll('.question-container'),
            (option) => {
              return Number(option.dataset.count);
            }
          ).reduce((p, i) => p + i, 0);

          container.querySelectorAll('.option').forEach((option) => {
            option.checked = false;
            option.classList.remove('highlight');

            if (Number(option.dataset.index) <= currentIndex && currentIndex !== 12) { 
              option.classList.add('highlight');
            }
          });
          event.currentTarget.checked = true;
        }

        if (!scaleSelect) {
          if (event.currentTarget.checked) {
            optionsChecked++; 
          } else {
            optionsChecked--; 
          }
        }

        if (questionCounter) {
          questionCounter.innerHTML = `${optionsChecked} selected`;
        }

        if (nextButton) {
          if (optionsChecked >= questionsCount) {
            nextButton.classList.remove('opacity-50');
          } else {
            nextButton.classList.add('opacity-50');
          }
        }

        save();
      });
    });

    const event = new Event('OnQuestionsLoaded');
    document.dispatchEvent(event);
  }
});
